export async function asyncMap<T>(arr: T[], callback: (val: T) => Promise<T>) {
  const promises = arr.map(async (item) => callback(item));

  return Promise.all(promises);
}
